<div
  class="rs-padding-top1 rs-padding-bottom1"
  *ngIf="setting?.optionCodeForDescription !== 'DNSND'"
>
  <div class="rs-flex-row rs-flex-middle-medium">
    <div class="rs-flex-column">
      <div class="rs-padding-bottom1">
        <span class="rs-txt-s4 rs-txt-purple rs-font-pxB">{{ setting?.name }}</span
        ><br />
        <span class="rs-txt-s4">{{ setting?.description }}</span>
      </div>
    </div>
    <div class="rs-flex-column rs-flex-shrink">
      <mprd-order-switch
        *ngIf="setting?.ibStatus !== OptionStatus.ERROR"
        [(option)]="setting"
        [selectedProduct]="product"
        (resultEmit)="onResult($event)"
      ></mprd-order-switch>
    </div>
  </div>
  <px-alert *ngIf="setting" [alertKey]="getAlertKey()"></px-alert>
  <px-alert
    *ngIf="
      setting?.optionCodeForDescription === 'EXCEEDING-ALARM' &&
      setting?.ibStatus === OptionStatus.ERROR
    "
    [alerts]="[
      {
        type: 'error',
        title: 'alarmThresholds.unavailable.error.title' | translate,
        description: 'alarmThresholds.unavailable.error.description' | translate,
        isClosable: false,
        taggingErrorType: 'backend'
      }
    ]"
  ></px-alert>
  <mprd-alarm-threshold
    *ngIf="
      setting &&
      setting?.optionCodeForDescription === 'EXCEEDING-ALARM' &&
      setting?.ibStatus == OptionStatus.ACTIVE
    "
    [option]="setting"
    [msisdn]="product?.accessNumber"
    data-cy="alarmThreshold"
  ></mprd-alarm-threshold>
</div>
<a
  href="javascript:void(0)"
  *ngIf="setting?.optionCodeForDescription === 'DNSND'"
  [routerLink]="['/details/option/', setting?.optionCodeForDescription || '', productType]"
  (click)="savePii(product?.accessNumber)"
  class="rs-link-no-decoration"
>
  <div class="rs-padding-top1 rs-padding-bottom1">
    <div class="rs-flex-row rs-flex-middle-medium">
      <div class="rs-flex-column">
        <div class="rs-padding-bottom1">
          <span class="rs-txt-s4 rs-txt-purple rs-font-pxB">{{ setting?.name }}</span
          ><br />
          <span class="rs-txt-s4">{{ setting?.description }}</span>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div class="rs-flex-columns">
          <span class="rs-panel-clickable-arrow" aria-hidden="true"></span>
        </div>
      </div>
    </div>
    <px-alert *ngIf="setting" [alertKey]="getAlertKey()"></px-alert>
  </div>
</a>
